import Vue from 'vue'
var numeral = require('numeral')
var moment = require('moment')

Vue.mixin({
  data () {
    return {}
  },
  methods: {
    checkCloseWebsocket () {
      // console.log(this.$socket)
      this.$socket.onclose = (errorClose) => this.websocket_closeerror(errorClose)
    },
    checkWebsocket () {
      // console.log(this.$socket)
      this.$socket.onerror = (error) => this.websocket_error(error)
    },
    reload () {
      location.reload()
      console.log('reload')
    },
    convert_sec (sec) {
      return moment.unix(sec).add(543, 'year').format('DD/MM/YYYY HH:mm')
    },
    time_sec (sec) {
      return moment(sec).format('HH:mm:ss')
    },
    time_formet_mm (sec) {
      return moment(sec).format('HH:mm')
    },
    dateFormatTHfrom (date) {
      return moment(date).locale('th').format('dddd DD/MM/YYYY')
    },
    dateFormat (date) {
      return moment(date).format('L')
    },
    monthFormat (str) {
      switch (str) {
        case '01': return 'ม.ค'
        case '02': return 'ก.พ'
        case '03': return 'มี.ค'
        case '04': return 'เม.ย'
        case '05': return 'พ.ค'
        case '06': return 'มิ.ย'
        case '07': return 'ก.ค'
        case '08': return 'ส.ค'
        case '09': return 'ก.ย'
        case '10': return 'ต.ค'
        case '11': return 'พ.ย'
        default: return 'ธ.ค'
      }
    },
    monthYearFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01': return 'มกราคม ' + date[0]
        case '02': return 'กุมภาพันธ์ ' + date[0]
        case '03': return 'มีนาคม ' + date[0]
        case '04': return 'เมษายน ' + date[0]
        case '05': return 'พฤษภาคม ' + date[0]
        case '06': return 'มิถุนายน ' + date[0]
        case '07': return 'กรกฎาคม ' + date[0]
        case '08': return 'สิงหาคม ' + date[0]
        case '09': return 'กันยายน ' + date[0]
        case '10': return 'ตุลาคม ' + date[0]
        case '11': return 'พฤศจิกายน ' + date[0]
        default: return 'ธันวาคม ' + date[0]
      }
    },
    numberFormat (str) {
      return numeral(str).format('0,0.00')
    },
    Soundclick () {
      var audio = document.getElementById('audio')
      audio.play()
      audio.currentTime = 0
      this.$store.state.timeServer = 300
    },
    SoundFaild () {
      var fail = document.getElementById('soundfaild')
      fail.play()
      fail.currentTime = 0
      this.$store.state.timeServer = 300
    },
    sayLang (text) {
      let language = 'UK English Female'
      switch (this.$store.state.lang.lang_id) {
        case 1:
          language = 'Thai Female'
          break
        case 2:
          language = 'UK English Female'
          break
        case 3:
          language = 'Chinese Female'
          break
      }
      setTimeout(
        // test
        function () {
          // responsiveVoice.setDefaultVoice(language)
          // responsiveVoice.speak(text)
          // eslint-disable-next-line no-undef
          responsiveVoice.speak(text, language)
        },
        100
      )
    }
  }
})
